import { upperFirst } from 'lodash';
import { Cell } from 'react-table';

import { CellText } from 'coreOld/elements';
import { AlignText } from 'coreOld/enums';
import { formatDate, getPercentage, roundNumberWithUom } from 'coreOld/utils';
import { IQuoteHistory } from 'partsOld/types';

const DECIMALS = 2;
const PAGE_BASIC_URL = '/pricing/profile/fixed-pricing';

export const defaultColumnStyle = { width: 100 };

const getPricingProfile = (item: IQuoteHistory) => {
  if (item.priceSourceType && item.priceSourceDiscountType) {
    return `${item.priceSourceType.charAt(0).toUpperCase()}-${item.priceSourceDiscountType
      .charAt(0)
      .toUpperCase()}`;
  }

  if (item.priceSourceType) {
    return item.priceSourceType.charAt(0).toUpperCase();
  }

  return '-';
};

const getProfile = (item: IQuoteHistory) => {
  if (!item.priceSourcePricingProfileName) {
    return '';
  }

  return item.priceSourcePricingProfileName.toUpperCase();
};

const getPriceSourcePricingProfileUrl = (item: IQuoteHistory) => {
  if (item.priceSourcePricingProfileId < 0) {
    return;
  }

  return `${PAGE_BASIC_URL}?pricing_profile=${item.priceSourcePricingProfileId}`;
};

const getMargin = (item: IQuoteHistory) => {
  if (!item.cost) {
    return '-';
  }
  const margin = (item.price - item.cost) / item.price;

  return getPercentage(margin);
};

export const columns = [
  {
    accessor: 'quoteCustomId',
    Header: 'Quote',
    Cell: ({ row }: Cell<IQuoteHistory>) => (
      <CellText
        mainText={row.original.quoteCustomId}
        subTexts={[formatDate(row.original.createdAt)]}
      />
    ),
    flex: 60,
  },
  {
    accessor: 'customerCompany',
    Header: 'Customer',
    Cell: ({ row }: Cell<IQuoteHistory>) => (
      <CellText
        mainText={row.original.customerCompany}
        subTexts={[row.original.customerCorporateUserName.toUpperCase()]}
      />
    ),
    flex: 100,
  },
  {
    accessor: 'quantity',
    Header: () => <CellText mainText="Quantity" alignText={AlignText.RIGHT} />,
    Cell: ({ row }: Cell<IQuoteHistory>) => (
      <CellText
        mainText={`${row.original.quantity} ${row.original.uom}`}
        alignText={AlignText.RIGHT}
      />
    ),
    flex: 100,
  },
  {
    accessor: 'cost',
    Header: () => <CellText mainText="Cost" alignText={AlignText.RIGHT} />,
    Cell: ({ row }: Cell<IQuoteHistory>) => (
      <CellText
        mainText={roundNumberWithUom(row.original.cost, DECIMALS, row.original.uom)}
        alignText={AlignText.RIGHT}
      />
    ),
    flex: 100,
  },
  {
    accessor: 'price',
    Header: () => <CellText mainText="Price" alignText={AlignText.RIGHT} />,
    Cell: ({ row }: Cell<IQuoteHistory>) => (
      <CellText
        mainText={roundNumberWithUom(row.original.price, DECIMALS, row.original.uom)}
        alignText={AlignText.RIGHT}
      />
    ),
    flex: 100,
  },
  {
    id: 1,
    Header: 'Margin',
    Cell: ({ row }: Cell<IQuoteHistory>) => <CellText mainText={getMargin(row.original)} />,
    flex: 100,
  },
  {
    accessor: 'priceSourceType',
    Header: 'Profile Type',
    Cell: ({ row }: Cell<IQuoteHistory>) => <CellText mainText={getPricingProfile(row.original)} />,
    flex: 100,
  },
  {
    accessor: 'priceSourcePricingProfileName',
    Header: 'Profile',
    Cell: ({ row }: Cell<IQuoteHistory>) => (
      <CellText
        mainText={getProfile(row.original)}
        isLink={true}
        url={getPriceSourcePricingProfileUrl(row.original)}
      />
    ),
    flex: 100,
  },
  {
    accessor: 'status',
    Header: 'Status',
    Cell: ({ row }: Cell<IQuoteHistory>) => <CellText mainText={upperFirst(row.original.status)} />,
    flex: 100,
  },
];
